import React, { useEffect, useState } from 'react';
import "./Tech.css";
import Lottie from "lottie-react";
import techAnimation from "../assests/TechAnimation.json";
import node from "../images/nodejs (2).png";
import python from "../images/python (1).png";
import react from "../images/physics (1).png";
import reactNative from "../images/React1.png";
import aws from "../images/icons8-amazon-web-services-240.png";
import js from "../images/js.png";
import azure from "../images/azure.png";
import java from "../images/java.png";
import icon from "../images/Frame-15-1.svg";
export default function Technologies() {
  const techData = [
    { img: node, name: "Node.js" },
    { img: python, name: "Python" },
    { img: react, name: "React js" },
    { img: react, name: "React Native" },
    { img: aws, name: "AWS" },
    { img: js, name: "Java Script" },
    { img: azure, name: "Azure" },
    { img: java, name: "Java" },
  ];

  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div>
      <div className="techHero">
        <div className="topCurve"></div>
        <div className="techCardFull">
          <div className={`logo_curve1 ${isScrolled ? "logo_curve1_scrolled" : ""}`}></div>
          <div className={`logo_curve2 ${isScrolled ? "logo_curve2_scrolled" : ""}`}></div>
          <div className={`menu-icon-curve1 ${isScrolled ? "menu-icon-curve1_scrolled" : ""}`}></div>
          <div className={`menu-icon-curve2 ${isScrolled ? "menu-icon-curve2_scrolled" : ""}`}></div>
          <div className="logo_curve1_Mo"></div>
          <div className="logo_curve2_Mo"></div>
          <div className="menu-icon-curve1_MV"></div>
          <div className="menu-icon-curve2_MV"></div>
          <div className="techContent">
            <h1 className="tech-title">Tech Stack</h1>
            <p>
              The services and frameworks you use to build the user experience,
              including the user interface and all the client-side functionality
              in your product.
            </p>
          </div>
          <div className="tech-animation">
            <Lottie animationData={techAnimation} loop={true} speed={0.1} />
          </div>
        </div>
      </div>

      <div className="tech-section">
        <div className="tech-grid">
          {techData.map((tech, index) => (
            <div className="tech-card" key={index}>
              <img src={tech.img} alt={tech.name} />
              <p>{tech.name}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="shared-section">
  <h1 className="shared-heading">
    SHARED RESPONSIBILITIES FOR ONE COMMON PURPOSE
  </h1>

  <p className="shared-subtext">
    Quinterra Soft works in synergy to achieve one goal: A stable product or MVP
  </p>
</div>
  <img src={icon} alt="icon" className="my-icon" />
</div>
  );
}

